import {Alert, AlertColor, Grid} from "@mui/material";
import React from "react";

const CustomBanner = ({message, severity}: { message: string, severity: AlertColor | undefined }) => {

    return (
        <Grid item xs={12} sm={12} md={12}>
            <Alert severity={severity} variant="filled"> {message}</Alert>
        </Grid>
    );
};

export default CustomBanner;